import React from 'react';

export default function DataCaptureAssistantChat(): JSX.Element {
  return <div>Data capture assistant placeholder</div>;
}
